import React, { useEffect, useState } from "react";
import { Table, Space, message } from "antd"; // Import Ant Design table
import { AiOutlineMail } from "react-icons/ai"; // Import mail icon
import { getQueries, updateQueryStatus } from "../../Web Apis/Apis";
import Loader from "../Loader/Loader";
import moment from "moment";
import { each } from "chart.js/helpers";

function Query() {
  const [queries, setQueries] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch the user queries (this would be replaced by your actual API call)
  const fetchQueries = async () => {
    try {
      setLoading(true);
      const response = await getQueries();
      console.log("queries", response?.data?.data);
      // const filterdata = response?.data?.data?.filter((each)=> each.adminId === id)
      const reverseQueries = [...response?.data?.data].reverse();

      const queryMaps = reverseQueries.map((each) => ({
        ...each,
        createdAt: moment(each.createdAt).format("MMM Do YY"),
      }));

      setQueries(queryMaps);
    } catch (error) {
      console.log("Error while fetch relation category", error.message);
      if (
        error.message === "Network Error" ||
        error.message.includes("ERR_INTERNET_DISCONNECTED")
      ) {
        // Handle internet disconnection
        return;
      }
      // Handle specific error cases
      if (error?.response?.status === 401) {
        window.alert(
          "Your account is logged in to another device, please login again !"
        );
        localStorage.clear();
        window.location.href = "/login";
      }
      if (error?.response?.status === 500) {
        message.error("Server not responding");
      }
    } finally {
      setLoading(false);
    }
  };

  // Load data when the component mounts
  useEffect(() => {
    fetchQueries();
  }, []);

  const updateStatus = async (id) => {
    try {
      setLoading(true);

      const response = await updateQueryStatus(id);
      if (response?.data?.success) {
        fetchQueries();
      }
    } catch (error) {
      console.log("Error while update query status", error);
      message.error("Error occured");
    } finally {
      setLoading(false);
    }
  };

  // Define the columns for the Ant Design table
  const columns = [
    {
      title: "S. No.",
      render: (_, __, index) => index + 1,
      key: "sno",
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Query",
      dataIndex: "message",
      key: "message",
    },
    {
      title: "Date",
      dataIndex: "createdAt",
      key: "createdAt",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => {
        const displayText = status ? status : "Pending";
        const color = status ? "green" : "orange";

        return <span style={{ color, fontWeight: "500" }}>{displayText}</span>;
      },
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          {/* Mailto link for sending an email */}
          <a
            onClick={() => updateStatus(record?.id)}
            href={`mailto:${record.email}`}
            title={`Send email to ${record.name}`}
          >
            <AiOutlineMail size={24} color="blue" />
          </a>
        </Space>
      ),
    },
  ];

  return (
    <div className="p-6 bg-gray-100 min-h-screen">
      {loading && <Loader />}
      <h1 className="text-3xl font-semibold mb-6 text-gray-800">
        Query Management
      </h1>

      <div className="bg-white shadow-md rounded-lg p-6">
        {/* Ant Design Table for displaying the user queries */}
        <Table
          columns={columns}
          dataSource={queries}
          pagination={{ pageSize: 10 }}
        />
      </div>
    </div>
  );
}

export default Query;
